/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/prefer-primitives */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { HEADER_HEIGHT, SECONDARY_NAV_WIDTH } from './constants';
export var PageHeader = function PageHeader() {
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Image, null));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var Wrapper = styled.div({
  position: 'fixed',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  top: "".concat(HEADER_HEIGHT, "px"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  left: "".concat(SECONDARY_NAV_WIDTH, "px")
});
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "467",
    height: "112",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100",
    height: "6",
    x: "24",
    y: "39",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "54",
    height: "6",
    x: "137",
    y: "39",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B778C",
    d: "m129.372 49.105 3.548-12.44h-1.299l-3.541 12.44h1.292Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "419.328",
    height: "20",
    x: "24",
    y: "68",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }));
};